// property values Component (property-setting editor)
import {fromJson} from "@core/jsonUtils";

export default (options = {}) => ({
    TYPE_CHOICES_MULTI: 'CHOICES_MULTI',
    TYPE_CHOICES_SINGLE: 'CHOICES_SINGLE',
    TYPE_COMPOSITE: 'COMPOSITE',
    init() {
        this.typeParamSelect = this.$el.querySelector("#propType");

        // Top-level choice list (CHOICES_* property)
        this.choicesSection = this.$refs.choicesSection;
        this.choicesContainer = this.$refs.choicesContainer;
        this.choiceTemplate = this.$refs.choiceTemplate;
        this.choiceIndex = 0;
        this.existingChoices = fromJson(this.$el.dataset.existingChoices);

        // Composite sub-fields (COMPOSITE property)
        this.subfieldsSection = this.$refs.subfieldsSection;
        this.subfieldsContainer = this.$refs.subfieldsContainer;
        this.subfieldTemplate = this.$refs.subfieldTemplate;
        this.subfieldChoiceTemplate = this.$refs.subfieldChoiceTemplate;
        this.repeatableSection = this.$refs.repeatableSection;

        // Continue sub-field indexes after the server-rendered ones.
        this.subfieldIndex = this.subfieldsContainer
            ? this.subfieldsContainer.querySelectorAll('.subfield-row').length
            : 0;
        if (this.subfieldsContainer) {
            this.subfieldsContainer.querySelectorAll('.subfield-row').forEach(row => {
                row.dataset.vindex = row.querySelectorAll('.subfield-choice-row').length;
                this.updateSubfieldVisibility(row);
            });
        }

        this.loadExistingChoices();
        this.updateVisibility();
    },
    updateVisibility() {
        if (!this.typeParamSelect) return;
        const v = this.typeParamSelect.value;
        const isChoice = v === this.TYPE_CHOICES_MULTI || v === this.TYPE_CHOICES_SINGLE;
        const isComposite = v === this.TYPE_COMPOSITE;

        if (this.choicesSection) {
            this.choicesSection.style.display = isChoice ? '' : 'none';
            if (isChoice && this.choicesContainer.children.length === 0) {
                this.addChoice();
            }
        }
        if (this.subfieldsSection) {
            this.subfieldsSection.style.display = isComposite ? '' : 'none';
            if (isComposite && this.subfieldsContainer.querySelectorAll('.subfield-row').length === 0) {
                this.addSubfield();
            }
        }
        if (this.repeatableSection) {
            this.repeatableSection.style.display = isComposite ? '' : 'none';
        }
    },
    addChoice(initial = {}) {
        const clone = this.choiceTemplate.cloneNode(true);
        clone.style.display = '';
        clone.id = '';

        clone.querySelectorAll('input').forEach(input => {
            input.name = input.name.replace('__index__', this.choiceIndex);
        });

        const idInput = clone.querySelector('.choice-id');
        const codeInput = clone.querySelector('.choice-code');
        const labelInput = clone.querySelector('.choice-label');
        if (initial.id) idInput.value = initial.id;
        if (initial.code) codeInput.value = initial.code;
        if (initial.label) labelInput.value = initial.label;

        this.choicesContainer.appendChild(clone);
        this.choiceIndex++;
    },
    handleRemoveChoice(event) {
        const removeBtn = event.target.closest('.remove-choice');
        if (!removeBtn) return;

        const row = removeBtn.closest('.choice-row');
        if (!row) return;

        row.querySelector('.choice-removed').value = 'true';
        row.style.display = 'none';
        row.querySelectorAll('input[required]').forEach(input => {
            input.removeAttribute('required');
        });
    },
    loadExistingChoices() {
        if (this.existingChoices && this.existingChoices.length > 0) {
            this.existingChoices.forEach(choice => {
                this.addChoice({
                    id: choice.propvId,
                    code: choice.propvCode,
                    label: choice.propvDisplayName
                });
            });
        }
    },

    // ----- Composite sub-fields -----
    addSubfield() {
        if (!this.subfieldTemplate) return;
        let html = this.subfieldTemplate.innerHTML.split('@@CIDX@@').join(this.subfieldIndex);
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const row = tmp.querySelector('.subfield-row');
        if (!row) return;
        row.dataset.vindex = 0;
        this.subfieldsContainer.appendChild(row);
        this.updateSubfieldVisibility(row);
        this.subfieldIndex++;
    },
    addSubfieldChoice(row) {
        if (!row || !this.subfieldChoiceTemplate) return;
        const cidx = row.dataset.cindex;
        const vidx = parseInt(row.dataset.vindex || '0', 10);
        let html = this.subfieldChoiceTemplate.innerHTML
            .split('@@CIDX@@').join(cidx)
            .split('@@VIDX@@').join(vidx);
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const choiceRow = tmp.querySelector('.subfield-choice-row');
        if (!choiceRow) return;
        row.querySelector('.subfield-choices-container').appendChild(choiceRow);
        row.dataset.vindex = vidx + 1;
    },
    updateSubfieldVisibility(row) {
        const typeSel = row.querySelector('.subfield-type');
        if (!typeSel) return;
        const v = typeSel.value;
        const isChoice = v === this.TYPE_CHOICES_MULTI || v === this.TYPE_CHOICES_SINGLE;
        const choicesBlock = row.querySelector('.subfield-choices');
        if (choicesBlock) {
            choicesBlock.style.display = isChoice ? '' : 'none';
            const container = row.querySelector('.subfield-choices-container');
            if (isChoice && container && container.querySelectorAll('.subfield-choice-row').length === 0) {
                this.addSubfieldChoice(row);
            }
        }
    },
    handleSubfieldClick(event) {
        const addChoiceBtn = event.target.closest('.add-subfield-choice');
        if (addChoiceBtn) {
            this.addSubfieldChoice(addChoiceBtn.closest('.subfield-row'));
            return;
        }
        const removeChoiceBtn = event.target.closest('.remove-subfield-choice');
        if (removeChoiceBtn) {
            const cr = removeChoiceBtn.closest('.subfield-choice-row');
            if (cr) {
                cr.querySelector('.subfield-choice-removed').value = 'true';
                cr.style.display = 'none';
            }
            return;
        }
        const removeFieldBtn = event.target.closest('.remove-subfield');
        if (removeFieldBtn) {
            const row = removeFieldBtn.closest('.subfield-row');
            if (row) {
                row.querySelector('.subfield-removed').value = 'true';
                row.style.display = 'none';
            }
        }
    }
});
